import {defineNuxtRouteMiddleware, navigateTo} from '#app';
import {ref} from '#imports';
import {Configuration, ProjectAnalyticsApi} from '~/openapi';

export default defineNuxtRouteMiddleware(async () => {
    const configuration = new Configuration({basePath: ''});
    const analyticsApi = new ProjectAnalyticsApi(configuration);
    const hasAccessToAnalytics = ref(false);
    hasAccessToAnalytics.value = await analyticsApi.checkAnalyticsAccess();

    if (!hasAccessToAnalytics.value) {
        return navigateTo({name: 'analytics-restricted'});
    }
});
